import { put } from 'core/middlewares/utilities';
import { cart } from 'core/use-cases';

/**
 * Orchestrate the service Cart Init Flow
 *
 */
export function* cartInit() {
  yield put(cart.actions.cartFetch.request());
}
